import { render } from "./SameDayDashboard.vue?vue&type=template&id=084996bf&scoped=true"
import script from "./SameDayDashboard.vue?vue&type=script&lang=js"
export * from "./SameDayDashboard.vue?vue&type=script&lang=js"

import "./SameDayDashboard.vue?vue&type=style&index=0&id=084996bf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084996bf"]])

export default __exports__